import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { Gantt, ViewMode } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";
import { LuSearch, LuCalendar, LuUser, LuClock, LuAlertTriangle } from "react-icons/lu";
import { connect } from "react-redux";
import { compose } from "redux";
import { LuCircleAlert } from "react-icons/lu"
//import { CSSTransition } from 'react-transition-group';
import { getDepartmentsActionData, getDepartments, getDepartmentsAction, addActionComments, editActionComments } from "../../store/actions/departmentActions";
import { editActionProgress, editAction } from "../../store/actions/riskActions";

import debounce from "lodash/debounce";
import { Disable } from 'react-disable';


import "./Gantt.css";

import Select from 'react-select'


import ActionOverlay from "../../components/Action/ActionOverlay";

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3b3b3b' : '#ccc',
        boxShadow: state.isFocused ? '0 0 0 1px #3b3b3b' : 'none',
        '&:hover': {
            borderColor: '#3b3b3b',
        },
        backgroundColor: '#EEF0ED',
        padding: 1,
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 999999999999, // Ensures the menu appears above other elements
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#3b3b3b' : state.isFocused ? '#EEF0ED' : 'white',
        color: state.isSelected ? 'white' : '#3b3b3b',
        '&:hover': {
            // backgroundColor: '#EEF0ED',
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#3b3b3b',
    }),
};



const statusMeta = {
    "Not started": { cls: "bg-gray-100 text-gray-700 border-gray-200" },
    "In progress": { cls: "bg-blue-100 text-blue-700 border-blue-200" },
    "Completed": { cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
    "Problem": { cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

function chipCls(label) {
    const m = label && statusMeta[label];
    return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${m ? m.cls : "bg-gray-100 text-gray-700 border-gray-200"
        }`;
}

function isCompleted(label) {
    return label === "Completed";
}

function isBehind(t) {
    try {
        if (t.styles && t.styles.backgroundColor === "#F07167") return true; // backend hint
        const start = new Date(t.start);
        const end = new Date(t.end);
        const now = new Date();
        const total = end - start;
        const elapsed = now - start;
        const frac = total > 0 ? elapsed / total : 0;
        const pct = Number(t.progress || 0);
        return pct < frac * 100 && !isCompleted(t.progressLabel);
    } catch {
        return false;
    }
}

function isOverdue(t) {
    try {
        return new Date(t.end) < new Date() && !isCompleted(t.progressLabel);
    } catch {
        return false;
    }
}

function AssigneeStack({ assignees = [], owner }) {
    const pics = [...assignees].slice(0, 3);
    return (
        <div className="flex -space-x-2 items-center">
            {pics.map((u, i) => (
                <img
                    key={i}
                    src={
                        u.avatar ||
                        "https://ui-avatars.com/api/?name=" +
                        encodeURIComponent(`${u.firstName || ""} ${u.lastName || ""}`)
                    }
                    title={`${u.firstName || ""} ${u.lastName || ""}`}
                    className="w-6 h-6 rounded-full border-2 border-white shadow"
                    alt=""
                />
            ))}
            {owner && owner.id ? (
                <img
                    src={
                        owner.avatar ||
                        "https://ui-avatars.com/api/?name=" +
                        encodeURIComponent(`${owner.firstName || ""} ${owner.lastName || ""}`)
                    }
                    title={`Owner: ${owner.firstName || ""} ${owner.lastName || ""}`}
                    className="w-6 h-6 rounded-full border-2 border-white shadow ring-1 ring-amber-400"
                    alt=""
                />
            ) : null}
        </div>
    );
}


const DashboardComponent = (props) => {


    const { actions_stats, getDepartmentsActionDataFN, departments, getDepartmentsFN, getDepartmentsActionFN, actions, addActionCommentsFN, editActionFN, editActionCommentsFN, activeDepartmentId, profile } = props;

    ////console.log("ACTIONS GANTT :", actions);
    // Step 1: Initialize state for input values
    const [tasks, setTasks] = useState([]);

    const [isLoading, setIsLoading] = useState(true);


    const [risk_id, setRiskId] = useState(null);
    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);


    // const [taskDescription, setTaskDescription] = useState("");


    // eslint-disable-next-line react-hooks/exhaustive-deps


    useEffect(() => {
        if (activeDepartmentId) {
            //alert(activeDepartmentId);
            if (profile.role !== "User") {
                getDepartmentsActionFN(activeDepartmentId);
                getDepartmentsActionDataFN(activeDepartmentId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeDepartmentId]);

    const departmentOptions = departments && departments.map(department => ({
        value: department.department_id,
        label: department.name
    }));

    const [activeDepartment, setActiveDepartment] = useState(activeDepartmentId ? activeDepartmentId : null);

    useEffect(() => {

        getDepartmentsFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {


        if (profile?.department_id && (profile.role === "User")) {
            //alert(profile.department_id);
            setActiveDepartment(profile.department_id);
            console.log(profile.department_id)
            getDepartmentsActionFN(profile.department_id);
            getDepartmentsActionDataFN(activeDepartmentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [profile]);

    useEffect(() => {


        if (activeDepartmentId) {
            setActiveDepartment(activeDepartmentId)

        }
    }, [activeDepartmentId]);

    const ganttWrapperRef = useRef(null);

    useEffect(() => {
        if (ganttWrapperRef.current) {
            // Use timeout to wait for Gantt to finish its own scroll logic
            setTimeout(() => {
                ganttWrapperRef.current.scrollLeft = 0;
            }, 100); // 100ms usually works — adjust if needed
        }
    }, [tasks]); // Runs every time tasks change

    /*
    useEffect(() => {
        if (departments?.length > 0) {
            //alert(1)
            setActiveDepartment(departments[0].department_id);
            getDepartmentsActionFN(departments[0].department_id);
            //////console.log(departments[0].department_id, departments);
            //select first department
        }
    }, [departments]);

    */



    //const [collapsedTasks, setCollapsedTasks] = useState([]);
    const handleExpanderClick = (task) => {
        setTasks(tasks.map(t => (t.id === task.id ? task : t)));
        //setCollapsedTasks(collapsedTasks.map(t => (t.id === task.id ? task : t)));
        ////console.log("On expander click Id:" + task.id);

    };

    const handleAddTask = (task) => {
        ////console.log(task);

        addActionCommentsFN(task.iid, "New Comment", activeDepartment);


    };


    useEffect(() => {
        const source = Array.isArray(actions_stats) ? actions_stats : actions;
        console.log("new tasks", source)
        setTasks(normalizeTasks(source));
    }, [actions_stats, actions]);


    function normalizeTasks(src) {
        const raw = Array.isArray(src) ? src : [];
        // keep only real action rows
        const onlyTasks = raw.filter(
            (t) => t && t.type === "task" && (t.iid != null || t.action_id != null)
        );
        // de-dup by iid/action_id
        const byId = new Map();
        for (const t of onlyTasks) {
            const key = t.iid ?? t.action_id ?? t.id;
            if (!byId.has(key)) byId.set(key, t);
        }
        let out = Array.from(byId.values());

        // guard: sometimes a project slips in; drop rows where name === project (if you never intend that)
        //out = out.filter((t) => t.name !== t.project);

        // optional: drop untitled
        out = out.filter((t) => (t.name || "").trim().length > 0);

        return out;
    }


    const closeAction = async (data, action_id) => {
        await updateControlServerData(data, action_id);                  // wait for save
        const fresh = await getDepartmentsActionDataFN(activeDepartment); // wait for store refresh

        // optional: immediate local derive (no waiting for useEffect)
        setTasks(normalizeTasks(Array.isArray(fresh) ? fresh : []));

        setIsActionOpen(false);
    };

    const openAction = (action) => {
        //console.log("action", action);
        if (!action.iid)
            return
        setActionId(action.iid);
        setRiskId(action.risk_id);
        setIsActionOpen(true);
    };


    const raw = Array.isArray(actions_stats) ? actions_stats : Array.isArray(actions) ? actions : [];

    // only tasks (skip any "project" rows)


    // local UI state
    const [q, setQ] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [onlyMine, setOnlyMine] = useState(false);

    const counts = useMemo(() => {
        let open = 0,
            closed = 0;
        tasks.forEach((t) => (isCompleted(t.progressLabel) ? closed++ : open++));
        return { open, closed, total: tasks.length };
    }, [tasks]);

    const meId = profile && profile.user_id ? Number(profile.user_id) : null;

    const filtered = useMemo(() => {
        let list = [...tasks];

        if (statusFilter !== "All") {
            list = list.filter((t) => (t.progressLabel || "Not started") === statusFilter);
        }

        if (q.trim()) {
            const L = q.toLowerCase();
            list = list.filter(
                (t) => (t.name || "").toLowerCase().includes(L) || (t.project || "").toLowerCase().includes(L)
            );
        }

        if (onlyMine && meId) {
            list = list.filter(
                (t) => (t.assignees || []).some((u) => Number(u.id) === meId) || (t.riskOwner && Number(t.riskOwner.id) === meId)
            );
        }

        // prioritize overdue/behind, then nearest due date
        list.sort((a, b) => {
            const sa = isOverdue(a) ? 2 : isBehind(a) ? 1 : 0;
            const sb = isOverdue(b) ? 2 : isBehind(b) ? 1 : 0;
            if (sa !== sb) return sb - sa;
            return new Date(a.end) - new Date(b.end);
        });

        return list;
    }, [tasks, q, statusFilter, onlyMine, meId]);


    const updateControlServerData = async (data, action_id) => {
        // adjust dates if you really need +1 day
        const updatedData = { ...data };
        if (updatedData.StartDate) {
            const d = new Date(updatedData.StartDate);
            d.setDate(d.getDate() + 1);
            updatedData.StartDate = d.toISOString().split("T")[0];
        }
        if (updatedData.EndDate) {
            const d = new Date(updatedData.EndDate);
            d.setDate(d.getDate() + 1);
            updatedData.EndDate = d.toISOString().split("T")[0];
        }

        setIsLoading(true);
        try {
            // IMPORTANT: await the thunk
            const saved = await editActionFN(risk_id, action_id, updatedData);
            return saved; // bubble up if you want
        } finally {
            setIsLoading(false);
        }
    };


    const handleProgressChange = (task, progress) => {
        if (!task.iid) {
            console.error("Task IID is missing.");
            return;
        }

        ////console.log("Task being updated:", JSON.parse(JSON.stringify(task)));

        // Update the backend with the new progress value
        props.editActionProgressFN(task.iid, task.progress)
            .then((updatedAction) => {
                ////console.log("Progress updated successfully:", updatedAction);

                // Update tasks in state to reflect the new progress
                setTasks((prevTasks) =>
                    prevTasks.map((t) => (t.iid === task.iid ? { ...t, progress: task.progress } : t))
                );
            })
            .catch((error) => {
                console.error("Failed to update progress:", error);
                alert("Failed to update progress. Please try again.");
            });
    };


    const priorityChip = (p) => {
        const label = (p || "").trim();
        const base =
            "text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-medium";

        switch (label) {
            case "Critical":
                return (
                    <span
                        className={`${base} bg-red-50 border-red-200 text-red-700 font-semibold`}
                    >
                        Critical
                    </span>
                );

            case "High":
                return (
                    <span
                        className={`${base} bg-red-50 border-red-200 text-red-700 font-semibold`}
                    >
                        High
                    </span>
                );

            case "Medium":
                return (
                    <span
                        className={`${base} bg-orange-50 border-orange-200 text-orange-600 font-semibold`}
                    >
                        Medium
                    </span>
                );

            case "Low":
                return (
                    <span
                        className={`${base} bg-yellow-50 border-yellow-200 text-yellow-600 font-medium`}
                    >
                        Low
                    </span>
                );

            default:
                return null;
        }
    };


    const [pageIndex, setPageIndex] = useState(0);
    const pageSize = 6;

    const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
    const canPreviousPage = pageIndex > 0;
    const canNextPage = pageIndex < totalPages - 1;

    const gotoPage = (i) => setPageIndex(Math.min(Math.max(i, 0), totalPages - 1));
    const previousPage = () => canPreviousPage && setPageIndex((p) => p - 1);
    const nextPage = () => canNextPage && setPageIndex((p) => p + 1);

    // reset/clamp when filters change or results shrink
    useEffect(() => { setPageIndex(0); }, [q, statusFilter]); // add others if you enable them
    useEffect(() => {
        if (pageIndex > totalPages - 1) setPageIndex(Math.max(0, totalPages - 1));
    }, [totalPages, pageIndex]);

    // slice after filtering
    const paged = useMemo(() => {
        const start = pageIndex * pageSize;
        return filtered.slice(start, start + pageSize);
    }, [filtered, pageIndex, pageSize]);

    return (
        <div className="w-full">
            {/* Top filters / counts */}
            <div className="mx-10 mt-6 mb-3 flex items-center justify-between">
                {/* left cluster (keep commented if not used) */}
                {/* <div className="flex items-center gap-2 text-sm">...</div> */}

                <div className="flex items-center gap-2">
                    <div className="relative">
                        <LuSearch className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                        <input
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="Search actions…"
                            className="pl-7 pr-3 py-1.5 w-64 border border-gray-300 rounded-lg text-sm
                   focus:outline-none focus:ring-0 focus:border-gray-400 focus:shadow-none
                   placeholder:text-gray-400"
                        />
                    </div>

                    <select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        className="border border-gray-300 rounded-lg text-sm px-2 py-1.5
                 focus:outline-none focus:ring-0 focus:border-gray-400"
                    >
                        <option>All</option>
                        <option>Not started</option>
                        <option>In progress</option>
                        <option>Problem</option>
                        <option>Completed</option>
                    </select>

                    {/* <label className="inline-flex items-center gap-2 text-sm px-2 py-1.5 border border-gray-300 rounded-lg cursor-pointer bg-white">
                        <input
                            type="checkbox"
                            className="accent-blue-600"
                            checked={onlyMine}
                            onChange={(e) => setOnlyMine(e.target.checked)}
                        />
                        Only mine
                    </label> */}
                </div>
            </div>
            <div className="table-wrapper mx-10 mt-8 shadow-xl rounded-lg overflow-hidden bg-white border border-gray-300">
                {/* Header */}
                <div className="grid grid-cols-[18px_1fr_120px_160px_130px_130px_130px] gap-4 px-4 py-4 bg-gray-50 text-xs font-semibold text-gray-700 border-b border-gray-300">
                    <div></div>
                    <div className="-ml-1">Title</div>
                    <div className="text-center">Priority</div>
                    <div className="text-center">Status</div>
                    <div className="-ml-1">Due</div>
                    <div>Owners</div>
                    <div className="text-right">Progress</div>
                </div>

                {/* Rows */}
                <div className="divide-y divide-gray-300">
                    {paged.length > 0 ? (
                        paged.map((t) => {
                            const overdue = isOverdue(t);
                            const behind = isBehind(t);
                            const pct = Math.max(0, Math.min(100, Math.round(t.progress || 0)));

                            return (
                                <button
                                    key={t.id}
                                    className="w-full text-left transition-colors duration-200 hover:bg-[#F8F8F8] focus:bg-[#F8F8F8]"
                                    onClick={() => openAction(t)}
                                >
                                    <div className="grid grid-cols-[18px_1fr_120px_160px_130px_130px_130px] gap-4 items-center px-4 py-4">
                                        <div></div>

                                        {/* Title + chips */}
                                        <div className="min-w-0 -ml-1">
                                            <div className="flex items-center gap-2">
                                                <span className="text-sm text-gray-700 font-normal">{t.name}</span>
                                                {behind && (
                                                    <span className="ml-1 text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-rose-50 text-rose-700 border border-rose-200">
                                                        <LuCircleAlert className="w-3 h-3" /> behind
                                                    </span>
                                                )}
                                                {overdue && (
                                                    <span className="ml-1 text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200">
                                                        <LuClock className="w-3 h-3" /> overdue
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        {/* Priority */}
                                        <div className="flex justify-center">{priorityChip(t.priority)}</div>

                                        {/* Status */}
                                        <div className="text-center">
                                            <span className={chipCls(t.portClass || t.progressLabel)}>
                                                {t.progressLabel || "Not started"}
                                            </span>
                                        </div>

                                        {/* Due */}
                                        <div className="text-sm text-gray-700 flex items-center gap-1 justify-start -ml-1">
                                            <LuCalendar className="w-4 h-4 text-gray-400" />
                                            {t.end ? new Date(t.end).toLocaleDateString() : "-"}
                                        </div>

                                        {/* Owners */}
                                        <div>
                                            <AssigneeStack assignees={t.assignees} />
                                        </div>

                                        {/* Progress */}
                                        <div className="text-right">
                                            <div className="text-sm font-medium text-gray-800">{pct}%</div>
                                            <div className="w-full h-1.5 bg-gray-200 rounded overflow-hidden mt-1">
                                                <div
                                                    className={`h-1.5 ${isCompleted(t.progressLabel)
                                                            ? "bg-emerald-500"
                                                            : behind
                                                                ? "bg-rose-500"
                                                                : "bg-blue-500"
                                                        }`}
                                                    style={{ width: `${pct}%` }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            );
                        })
                    ) : (
                        <div className="p-8 text-center text-gray-500">
                            No actions match your filters.
                        </div>
                    )}
                </div>
            </div>

            {/* Pagination */}
            <div className="mx-10 mt-4 mb-8">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="text-sm text-gray-600">
                        Showing{" "}
                        <strong>
                            {filtered.length === 0 ? 0 : pageIndex * pageSize + 1}–
                            {Math.min((pageIndex + 1) * pageSize, filtered.length)}
                        </strong>{" "}
                        of <strong>{filtered.length}</strong>
                    </div>

                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => gotoPage(0)}
                            disabled={!canPreviousPage}
                            className={`px-3 py-1.5 text-sm rounded border ${canPreviousPage ? "border-gray-300 hover:bg-gray-50" : "border-gray-200 text-gray-400 cursor-not-allowed"
                                }`}
                        >
                            « First
                        </button>
                        <button
                            onClick={previousPage}
                            disabled={!canPreviousPage}
                            className={`px-3 py-1.5 text-sm rounded border ${canPreviousPage ? "border-gray-300 hover:bg-gray-50" : "border-gray-200 text-gray-400 cursor-not-allowed"
                                }`}
                        >
                            ‹ Prev
                        </button>

                        <span className="text-sm text-gray-700 px-2">
                            Page <strong>{pageIndex + 1}</strong> of <strong>{totalPages}</strong>
                        </span>

                        <button
                            onClick={nextPage}
                            disabled={!canNextPage}
                            className={`px-3 py-1.5 text-sm rounded border ${canNextPage ? "border-gray-300 hover:bg-gray-50" : "border-gray-200 text-gray-400 cursor-not-allowed"
                                }`}
                        >
                            Next ›
                        </button>
                        <button
                            onClick={() => gotoPage(totalPages - 1)}
                            disabled={!canNextPage}
                            className={`px-3 py-1.5 text-sm rounded border ${canNextPage ? "border-gray-300 hover:bg-gray-50" : "border-gray-200 text-gray-400 cursor-not-allowed"
                                }`}
                        >
                            Last »
                        </button>
                    </div>
                </div>
            </div>



            <Popup
                open={isActionOpen}
                contentStyle={{
                    overflow: 'auto',
                    maxHeight: '80vh',
                    width: '900px',
                    marginTop: '14vh'
                }}
            >
                <ActionOverlay
                    closeAction={closeAction}
                    risk_id={risk_id}
                    action_id={action_id}
                />
            </Popup>
        </div>
    );

};




const mapStateToProps = (state) => {
    console.log(state.department)
    return {
        departments: state.department.departments,
        actions: state.department.actions,
        profile: state.profile.profile,
        actions_stats: state.department.actions_data

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDepartmentsFN: () => dispatch(getDepartments()),
        getDepartmentsActionFN: (department_id) => dispatch(getDepartmentsAction(department_id)),
        getDepartmentsActionDataFN: (department_id) => dispatch(getDepartmentsActionData(department_id)),
        addActionCommentsFN: (action_id, comments, department_id) => dispatch(addActionComments(action_id, comments, department_id)),
        editActionCommentsFN: (comment_iid, comments, department_id) => dispatch(editActionComments(comment_iid, comments, department_id)),
        editActionProgressFN: (action_id, progress) => dispatch(editActionProgress(action_id, progress)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(DashboardComponent);
